<ion-header
  [ngClass]="{
    'ion-no-border': 'true',
    'ion-no-padding': isHeaderTranslucent,
  }"
>
  @if (!isHeaderTranslucent) {
    <div
      [ngClass]="{
        'page-container__header': 'true',
      }"
    >
      <div class="page-container__header-title">
        @if (isNeedBack) {
          <img [src]="arrowRight" class="back" (click)="back()" />
        }
        <app-text
          [textSize]="TextSizes.h1Header"
          [textType]="TextType.base"
          [text]="headerName"
        ></app-text>
      </div>
      @if (isShowVersion) {
        <div class="page-container__header-version">
          <app-text
            [textSize]="TextSizes.mobBody"
            [textType]="TextType.base"
            [text]="'ver ' + appInfo.version"
            class="version"
          ></app-text>
        </div>
      }
      <span class="header-content-mob">
        <ng-content select="[header-content-mob]"></ng-content>
      </span>
    </div>
  }
</ion-header>

@if (tabsLinks.length && !isModalView) {
  <div class="tabs-container">
    <ion-grid>
      <ion-row>
        <ion-col class="tabs-container__col-menu" size="2.5">
          <div class="menu-wrapper"></div
        ></ion-col>
        @if (currentPlatform$ | async; as platform) {
          <ion-col class="tabs-container__col-content">
            <div class="tabs">
              @for (link of tabsLinks; track link) {
                <a [routerLink]="link.url" [routerLinkActive]="'active'">
                  <app-text
                    [textSize]="TextSizes.h1Header"
                    [textType]="TextType.base"
                    [text]="link.nameMobile || link.name"
                  ></app-text
                ></a>
              }
            </div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
  </div>
}

<ng-content></ng-content>

@if (currentPlatform$ | async; as platform) {
  @if (isDataLoaded$ | async) {
    @if (platform !== CurrentPlatform.desktop) {
      @if (needFooter) {
        <ion-footer class="ion-no-border">
          <ion-toolbar>
            <ng-content select="[footer-content-mob]"></ng-content>
          </ion-toolbar>
        </ion-footer>
      }
    }
  }
}
